// return Promise with json after setting json status with res status
const fetchWithToken = async (method = "GET", path, body) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${window.sessionStorage.getItem("jwt")}`,
  };

  return fetch(path, {
    headers,
    method,
    mode: "cors",
    body: body ? JSON.stringify(body) : null,
  }).then(async (res) => {
    const json = await res.json();
    json.status = res.status;
    // jwt expired, trigger event to redirect
    if (json.errorCode === 0) {
      console.log("expired jwt, clearing session storage");
      window.sessionStorage.clear(); // clear the data to trigger RouteProtection
      window.dispatchEvent(new Event("storage")); // trigger the storage event in RouteProtection
    }
    return json;
  });
};

export { fetchWithToken };
